// @ts-nocheck

import { downloadRequestWithToken, fetchRequest } from './index';
import { convertFromMToKm } from '../pure/unitConversions';
const convertFromServer = reportItem => ({
  ...reportItem,
  kilometrage: convertFromMToKm(reportItem.kilometrage)
});

/**
 * Получение отчета
 */
export const fetchReportFuelConsumption = async params => {
  const report = await fetchRequest.get('/report/fuel-consumption', {
    ...params
  });
  return report.map(convertFromServer);
};

/**
 * Печать отчета
 */
export const printReportFuelConsumption = async params => {
  const isPrinted = await downloadRequestWithToken('/report/fuel-consumption/print', {
    ...params
  });
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};
export default {
  fetchReportFuelConsumption,
  printReportFuelConsumption
};
